<form [formGroup]="milestoneFormGroup">
    <kendo-formfield class="text" showHints="initial">
        <kendo-label class="form-label" text="{{'schedule-data.dialog.subject' | translate}} *" [infotooltip]="'meilenstein.betreff'"></kendo-label>
        <kendo-textbox formControlName="betreff" appinfotext="betreff" 
        [maxlength]="200" [appinfotext]="'meilenstein.betreff'" [disabled]="isUpdatedInProjektBericht"
        ></kendo-textbox>
    </kendo-formfield>

    <kendo-formfield class="text" showHints="initial">
        <kendo-label class="form-label" text="{{'schedule-data.dialog.datePlan' | translate}} *" [infotooltip]="'meilenstein.datumplan'"></kendo-label>
        <kendo-datepicker 
            formControlName="datumPlan" 
            appinfotext="Datum Plan" 
            [appinfotext]="'meilenstein.datumplan'"
            [format]="dateFormat"
            [incompleteDateValidation]="true"
            [disabled]="isUpdatedInProjektBericht"
            >
        </kendo-datepicker>
    </kendo-formfield>

    <kendo-formfield class="text" showHints="initial">
        <kendo-label class="form-label" text="{{'schedule-data.dialog.dateActual' | translate}}" [infotooltip]="'meilenstein.datumist'"></kendo-label>
        <kendo-datepicker formControlName="datumIst" 
            appinfotext="Datum Ist" 
            [appinfotext]="'meilenstein.datumist'"
            [format]="dateFormat"
            [incompleteDateValidation]="true"
            [disabled]="!isUpdatedInProjektBericht">
        </kendo-datepicker>
    </kendo-formfield>

    <kendo-formfield class="text" showHints="initial">
        <kendo-label class="form-label" text="{{'schedule-data.dialog.location' | translate}}" [infotooltip]="'meilenstein.ort'"></kendo-label>
        <kendo-textbox formControlName="ort" appinfotext="ort" [maxlength]="200" [appinfotext]="'meilenstein.ort'"></kendo-textbox>
    </kendo-formfield>

    <kendo-formfield class="text" showHints="initial">
        <kendo-label class="form-label" text="{{'schedule-data.dialog.description' | translate}}" [infotooltip]="'meilenstein.beschreibung'"></kendo-label>
        <kendo-textarea formControlName="beschreibung" appinfotext="beschreibung" [attr.aria-label]="'meilenstein.beschreibung' | translate" [maxlength]="400" [rows]="8" [appinfotext]="'meilenstein.beschreibung'"></kendo-textarea>
    </kendo-formfield>
</form>

<kendo-dialog-actions>
    <button kendoButton class="cancel-button" (click)="onCancelClick()"  translate>
        <i></i>&nbsp;
        schedule-data.dialog.cancel
    </button>
    <button kendoButton class="confirm-button" (click)="onSaveClick()" [disabled]="isSaveDisabled" translate>
        <i></i>&nbsp;
        schedule-data.grid.add
    </button>
</kendo-dialog-actions>